// The profile's catalogue tabs (TX-US-0034, TX-US-0042), and which one an address names. Each is
// a place with an address - `?tab=quotes` - so a link opens the tab it means and Back returns to
// the one left. The onboarding sheets are the path's stages, not tabs (path.js).

export const TABS = [
  { key: 'details', label: 'Details' },
  { key: 'quotes', label: 'Quotes' },
  { key: 'ratings', label: 'Ratings' },
];

export const DEFAULT_TAB = 'details';

// The tab the address names; Details when it names none, or one that does not exist.
export const tabFrom = (searchParams) => {
  const named = searchParams.get('tab');
  return TABS.some((tab) => tab.key === named) ? named : DEFAULT_TAB;
};

// The address with `key`'s tab open; what else it holds - the open stage - is kept.
export function tabSearch(searchParams, key) {
  const next = new URLSearchParams(searchParams);
  next.set('tab', key);
  return `?${next}`;
}
